import type { Moment } from '@this/lib/moment';
import moment from '@this/lib/moment';

export interface OptionPlanArgs {
  id: number;
  name: string;
  key?: string;
  created_at: string;
  updated_at: string;
}

class OptionPlan {
  id: number;
  name: string;
  key?: string;
  createdAt: Moment;
  updatedAt: Moment;

  constructor(args: OptionPlanArgs) {
    this.id = args.id;
    this.name = args.name;
    this.key = args.key;
    this.createdAt = moment(args.created_at);
    this.updatedAt = moment(args.updated_at);
  }
}

// OptionPlan::FIXTURESのTypeScript版
export const OPTION_PLAN_NAMES: Record<number, string> = {
  1: 'マーケットログ',
  2: 'プロジェクト按分',
  3: 'AI日当連携',
  4: '移動距離・時間判定モジュール',
  5: '支払い期日変更オプション',
  6: '原価計算オプション',
  7: 'Express精算委託',
  8: 'IPアドレス制限・固定',
  9: '請求書分割',
  10: '多言語翻訳',
  11: 'ホテル市町村別旅費規程',
  12: '申請項目マスタ',
  13: '２営業日請求',
  14: '３営業日請求',
  15: '4営業日請求',
  16: 'プレミアムサポート対応',
  17: '出張報告オプション',
  18: 'カスタムワークフロー',
  19: '一括承認・却下/在庫定期自動チェック',
  20: 'ラクス連携オプション',
  21: '領収書発行オプション'
};

// IDからキーへのマッピング（OptionPlan::FIXTURESのキー名）
export const OPTION_PLAN_KEYS: Record<number, string> = {
  1: 'market_log',
  2: 'project_share',
  3: 'daily_allowance',
  4: 'restriction_distance_and_time',
  5: 'payment_change_option',
  6: 'expenses_account_type',
  7: 'express_outsourcing',
  8: 'ip_address_fix_or_restriction',
  9: 'billing_separation',
  10: 'i18n',
  11: 'expense_by_municipality',
  12: 'approve_item',
  13: 'billing_at_second_business_day',
  14: 'billing_at_third_business_day',
  15: 'billing_at_4th_business_day',
  16: 'premium_support',
  17: 'trip_report',
  18: 'custom_workflow',
  19: 'bulk_approve',
  20: 'rakus',
  21: 'receipt'
};

// キーからIDへの逆引きマッピング
export const OPTION_PLAN_KEY_TO_ID: Record<string, number> = Object.entries(OPTION_PLAN_KEYS).reduce(
  (acc, [id, key]) => {
    acc[key] = Number(id);
    return acc;
  },
  {} as Record<string, number>
);

export const getOptionPlanName = (idOrKey: number | string): string => {
  // 数値の場合はそのまま使用
  if (typeof idOrKey === 'number') {
    return OPTION_PLAN_NAMES[idOrKey] || `オプション ${idOrKey}`;
  }

  // 文字列の場合はキーからIDを取得
  const id = OPTION_PLAN_KEY_TO_ID[idOrKey];
  if (id) {
    return OPTION_PLAN_NAMES[id] || `オプション ${id}`;
  }

  // 見つからない場合はキーをそのまま返す
  return idOrKey;
};

export const getOptionPlanKey = (id: number): string => {
  return OPTION_PLAN_KEYS[id] || '';
};

export default OptionPlan;
